<template>
  <div>
    <el-dialog :visible.sync="notCheckInVisibleProxy" width="45%" :modal-append-to-body="false" center :top="`18px`">
      <div slot="title">
        請說明未報到情況
      </div>
      <div style="font-weight: 500;">原因說明</div>
      <el-input v-model="notCheckInReasonProxy" type="textarea" rows="5" placeholder="請輸入原因" style="margin-top:12px" />

      <div slot="footer" style="width:100%; display: flex; justify-content: space-around;">
        <el-button round @click="notCheckInVisibleProxy = false" style="width: 45%;">取消</el-button>
        <el-button round type="primary" style="width: 45%;" @click="$emit('confirm-not-check-in')">未報到</el-button>
      </div>
    </el-dialog>

    <el-dialog title="取消訂單原因" :visible.sync="cancelVisibleProxy" width="650px" :modal-append-to-body="false" :show-close="false" center :top="`18px`">
      <el-input v-model="cancelReasonProxy" type="textarea" :rows="8" placeholder="請輸入取消原因（選填）" />

      <div slot="footer" style="width:100%; display: flex; justify-content: space-around;">
        <el-button round style="width: 45%;" @click="$emit('dismiss-cancel')">暫不處理</el-button>
        <el-button round class="cancel-order-btn" style="width: 45%;" @click="$emit('confirm-cancel')">確定取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="處理退款原因" :visible.sync="refundVisibleProxy" width="650px" :modal-append-to-body="false" :show-close="false" center :top="`18px`">
      <el-input v-model="refundReasonProxy" type="textarea" :rows="8" placeholder="請輸入退款原因（選填）" />

      <div slot="footer" style="width:100%; display: flex; justify-content: space-around;">
        <el-button round style="width: 45%;" @click="$emit('dismiss-refund')">暫不處理</el-button>
        <el-button round class="cancel-order-btn" style="width: 45%;" @click="$emit('confirm-refund')">確定退款</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ViewOrderReasonDialogsPartial',
  props: {
    notCheckInVisible: { type: Boolean, default: false },
    notCheckInReason: { type: String, default: '' },
    cancelVisible: { type: Boolean, default: false },
    cancelReason: { type: String, default: '' },
    refundVisible: { type: Boolean, default: false },
    refundReason: { type: String, default: '' },
  },
  computed: {
    notCheckInVisibleProxy: {
      get() {
        return this.notCheckInVisible
      },
      set(val) {
        this.$emit('update:notCheckInVisible', val)
      },
    },
    notCheckInReasonProxy: {
      get() {
        return this.notCheckInReason
      },
      set(val) {
        this.$emit('update:notCheckInReason', val)
      },
    },
    cancelVisibleProxy: {
      get() {
        return this.cancelVisible
      },
      set(val) {
        this.$emit('update:cancelVisible', val)
      },
    },
    cancelReasonProxy: {
      get() {
        return this.cancelReason
      },
      set(val) {
        this.$emit('update:cancelReason', val)
      },
    },
    refundVisibleProxy: {
      get() {
        return this.refundVisible
      },
      set(val) {
        this.$emit('update:refundVisible', val)
      },
    },
    refundReasonProxy: {
      get() {
        return this.refundReason
      },
      set(val) {
        this.$emit('update:refundReason', val)
      },
    },
  },
}
</script>
